import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, Subject, throwError } from "rxjs";
import { map, retry, catchError } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ApiService {

//  public SERVER_BASEURL = "http://localhost:5001/";
//  public SERVER_BASEURL_ITI = "http://localhost:5001/";
 public SERVER_BASEURL = "https://grsnodetest.nimiquestionbank.in/";  // Grivence service
 public SERVER_BASEURL_ITI = "https://nodetest.nimiquestionbank.in/"; // ITI Service .. 
 

    //public SERVER_BASEURL1 = "http://164.100.68.244:8082/api/getTrainees/";
    public SERVER_BASEURL1 = "https://api.ncvtmis.gov.in/nimi/api/getTrainees/";
    //public SERVER_BASEURL2= "https://api.ncvtmis.gov.in/nimi/api/UploadTraineeRegNumbers/";
    // public SERVER_BASEURL1 = "https://164.100.213.13/api/getTrainees/";
    // //public SERVER_BASEURL2= "https://164.100.213.13/api/UploadTraineeRegNumbers/";
    public SERVER_BASEURL2 = "https://nimionlineadmission.in/dgt/upload_api.php";
  public ccref_url = "https://nimionlineadmission.in/AITTCBT-FEES22/Check_CCAvenue.php?ccav=";
  public ccref_url11 = "http://192.168.0.159/nimi_projects/SSW/ccavanue.php";
  public ccrefupdate_url =  "https://www.nimionlineadmission.in/AITTCBT-FEES22/Check_CCAvenuefull.php?ccav=";

  // ('https://sms.nettyfish.com/vendorsms/pushsms.aspx?apikey=9acf13b0-566f-47f9-b206-fe62af6f48da&clientId=a3b6b0ab-e393-44d4-aab0-1a3b69501f70&msisdn=' . $mobile . '&sid=NIMIAP&msg=Your%20OTP%20is%20'.$otp.'%20for%20reference%20number%20'.$regno.'%20-%20NIMI&fl=0&gwid=2')
  //9442507934
  public cc_mob = 'https://sms.nettyfish.com/vendorsms/pushsms.aspx?apikey=9acf13b0-566f-47f9-b206-fe62af6f48da&clientId=a3b6b0ab-e393-44d4-aab0-1a3b69501f70&msisdn=9597151452&sid=NIMIAP&msg=Your%20OTP%20is%20'+'77777'+'%20for%20reference%20number%20'+22222+'%20-%20NIMI&fl=0&gwid=2';

  // public cc_mob = 'https://sms.nettyfish.com/vendorsms/pushsms.aspx?apikey=9acf13b0-566f-47f9-b206-fe62af6f48da&clientId=a3b6b0ab-e393-44d4-aab0-1a3b69501f70&msisdn=9597151452&sid=NIMIAP&msg=Your OTP Number is '+9999+' for reference number '+'NAN123456'+'- NIMI&fl=0&gwid=2';



  constructor(private httpClient: HttpClient) { }

  insertFamilyHead(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL + "formfees/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  liststatecbtfee() {
    return this.httpClient.get(this.SERVER_BASEURL + "liststatecbtfee/").pipe(
      map((data) => {
        //alert(data);
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  liststate() {
    return this.httpClient.get(this.SERVER_BASEURL + "listITIstate/").pipe(
      map((data) => {
        //alert(data);
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  fn_click(){
    return this.httpClient.get(this.SERVER_BASEURL + "fn_click/").pipe(
      map((data) => {
        //alert(data);
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }
  ccrefStatus(args: any) {
    return this.httpClient.post(this.ccref_url , args).pipe(
      map((data) => {
        //alert(data);
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  ccrefUpdateStatus(args: any) {
    return this.httpClient.get(this.ccrefupdate_url + args).pipe(
      map((data) => {
        //alert(data);
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  listIticode() {
    return this.httpClient.get(this.SERVER_BASEURL + "listIticode/").pipe(
      map((data) => {
        //alert(data);
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }



  enterState(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + 'enterState/', args).pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }

  enterIticode(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + 'enterIticode/', args).pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }

  enterTrade(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + 'enterTrade/', args).pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }


  enterEriTrade(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + 'enterEriTrade/', args).pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }

  enterEriInvgName(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + 'enterEriInvgName/', args).pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }

  enterEriRollno(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + 'enterEriRollno/', args).pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    )
  }

  checkLogin(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "checkLogin/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  candidateLoginForm(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "candidateLoginForm/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  checknotifyLogin(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "checknotifyLogin/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  candidate_iti(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "candidate_iti/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  candidate_map_invig(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "candidate_map_invig/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  trackIdCheck(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "trackIdCheck/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  trackIdEri(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "trackIdEri/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  updateeri(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "updateeri/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  updatecri(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "updatecri/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  trackIdCheckCandidate(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "trackIdCheckCandidate/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  trackIdPdu(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "trackIdPdu/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  trackIdDirNIMIview(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "trackIdDirNIMIview/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  trackIdPduBulkregno(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "trackIdPduBulkregno/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  trackIdDirnimiBulkregno(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "trackIdDirnimiBulkregno/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  trackIdDirNIMIregno(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "trackIdDirNIMIregno/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  trackIdPduview(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "trackIdPduview/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  trackIdDirnimiview(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "trackIdDirnimiview/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  trackIdEriview(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "trackIdEriview/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  trackIdCriview(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "trackIdCriview/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  checkLeriregno(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "checkLeriregno/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  checkLcriregno(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "checkLcriregno/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  eriiticode(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "eriiticode/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  insertEriForm(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL + "insertEriForm/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  insertbdnuForm(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL + "insertbdnuForm/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  insertNIMIForm(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL + "insertNIMIForm/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  insertNIMIFormwithoutupload(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL + "insertNIMIFormwithoutupload/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  insertCriForm(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL + "insertCriForm/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  adminLogin(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "adminLogin/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  candidateLogin(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "candidateLogin/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  eriList() {
    return this.httpClient.get(this.SERVER_BASEURL + "eriList/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  criList() {
    return this.httpClient.get(this.SERVER_BASEURL + "criList/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


//query: string, page: number, offset: number
//this.SERVER_BASEURL + "pduList?q=" + query + "&page=" + page + "&offset=" + offset
  pduList() {
    return this.httpClient.get(this.SERVER_BASEURL + "pduList/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  //query: string, page: number, offset: number
  //?q=" + query + "&page=" + page + "&offset=" + offset
  pduList_count() {
    return this.httpClient.get(this.SERVER_BASEURL + "pduList_count/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }
  
  dirnimiList(query: string, page: number, offset: number){
    return this.httpClient.get(this.SERVER_BASEURL + "dirnimiList?q=" + query + "&page=" + page + "&offset=" + offset).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }
  dirnimiList_count(query: string, page: number, offset: number) {
    return this.httpClient.get(this.SERVER_BASEURL + "dirnimiList_count?q=" + query + "&page=" + page + "&offset=" + offset).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  eriPendingList() {
    return this.httpClient.get(this.SERVER_BASEURL + "eriPendingList/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  pduPendingList() {
    return this.httpClient.get(this.SERVER_BASEURL + "pduPendingList/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  eriRes_RejList() {
    return this.httpClient.get(this.SERVER_BASEURL + "eriRes_RejList/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  criRes_RejList() {
    return this.httpClient.get(this.SERVER_BASEURL + "criRes_RejList/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  pduRes_RejList() {
    return this.httpClient.get(this.SERVER_BASEURL + "pduRes_RejList/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  dirnimiRes_RejList() {
    return this.httpClient.get(this.SERVER_BASEURL + "dirnimiRes_RejList/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  // shipped_verified_list() {
  //   return this.httpClient.get(this.SERVER_BASEURL + "shipped_verified_list/").pipe(
  //     map((data) => {

  //       return data;
  //     }),
  //     retry(1),
  //     catchError(this.handleError)
  //   );
  // }

  shipped_verified_list(query: string, page: number, offset: number) {
    return this.httpClient.get(this.SERVER_BASEURL + "shipped_verified_list?q=" + query + "&page=" + page + "&offset=" + offset).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  shipped_verified_list_count(query: string, page: number, offset: number) {
    return this.httpClient.get(this.SERVER_BASEURL + "shipped_verified_list_count?q=" + query + "&page=" + page + "&offset=" + offset).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  listbulkticketId(query_mat_two: string, page_mat_two: number, offset_mat_two: number) {
    return this.httpClient.get(this.SERVER_BASEURL + "listbulkticketId?q=" + query_mat_two + "&page=" + page_mat_two + "&offset=" + offset_mat_two).pipe(
      map((data) => {
        //alert(data);
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  listbulkticketId_count(query_mat_two: string, page_mat_two: number, offset_mat_two: number) {
    return this.httpClient.get(this.SERVER_BASEURL + "listbulkticketId_count?q=" + query_mat_two + "&page=" + page_mat_two + "&offset=" + offset_mat_two).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  listDirnimiticketId(query_mat_two: string, page_mat_two: number, offset_mat_two: number) {
    return this.httpClient.get(this.SERVER_BASEURL + "listDirnimiticketId?q=" + query_mat_two + "&page=" + page_mat_two + "&offset=" + offset_mat_two).pipe(
      map((data) => {
        //alert(data);
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  listDirnimiticketId_count(query_mat_three: string, page_mat_three: number, offset_mat_three: number) {
    return this.httpClient.get(this.SERVER_BASEURL + "listDirnimiticketId_count?q=" + query_mat_three + "&page=" + page_mat_three + "&offset=" + offset_mat_three).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  shipped_verified_list_verifycc() {
    return this.httpClient.get(this.SERVER_BASEURL + "shipped_verified_list_verifycc/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }
  eriStatusList(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "eriStatusList/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  eristatus(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "eristatus/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  cristatus(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "cristatus/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  pdustatus(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "pdustatus/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  dirnimistatus(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "dirnimistatus/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  ccrefUpdatetbl(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "ccrefUpdatetbl/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  quick_pdustatus(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "quick_pdustatus/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  eriStatusListCount() {
    return this.httpClient.get(this.SERVER_BASEURL + "eriStatusListCount/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  ccverifycount() {
    return this.httpClient.get(this.SERVER_BASEURL + "ccverifycount/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  eristatusresolvecount() {
    return this.httpClient.get(this.SERVER_BASEURL + "eristatusresolvecount/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  eristatuspendingcount() {
    return this.httpClient.get(this.SERVER_BASEURL + "eristatuspendingcount/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  eristatusrejectcount() {
    return this.httpClient.get(this.SERVER_BASEURL + "eristatusrejectcount/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }
  bdnustatuscount() {
    return this.httpClient.get(this.SERVER_BASEURL + "bdnustatuscount/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  singletotalcount() {
    return this.httpClient.get(this.SERVER_BASEURL + "singletotalcount/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  singleresolvecount() {
    return this.httpClient.get(this.SERVER_BASEURL + "singleresolvecount/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  singlerejectcount() {
    return this.httpClient.get(this.SERVER_BASEURL + "singlerejectcount/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  singlependingcount() {
    return this.httpClient.get(this.SERVER_BASEURL + "singlependingcount/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  bulktotalcount() {
    return this.httpClient.get(this.SERVER_BASEURL + "bulktotalcount/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  bulkpendingcount() {
    return this.httpClient.get(this.SERVER_BASEURL + "bulkpendingcount/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  bulkresolvecount() {
    return this.httpClient.get(this.SERVER_BASEURL + "bulkresolvecount/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  bulkrejectcount() {
    return this.httpClient.get(this.SERVER_BASEURL + "bulkrejectcount/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  dirnimitotalcount() {
    return this.httpClient.get(this.SERVER_BASEURL + "dirnimitotalcount/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  dirnimipendingcount() {
    return this.httpClient.get(this.SERVER_BASEURL + "dirnimipendingcount/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  dirnimiresolvecount() {
    return this.httpClient.get(this.SERVER_BASEURL + "dirnimiresolvecount/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  dirnimirejectcount() {
    return this.httpClient.get(this.SERVER_BASEURL + "dirnimirejectcount/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }
  
  pdustatusresolvecount() {
    return this.httpClient.get(this.SERVER_BASEURL + "pdustatusresolvecount/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  pdustatuspendingcount() {
    return this.httpClient.get(this.SERVER_BASEURL + "pdustatuspendingcount/").pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  pdustatusrejectcount() {
    return this.httpClient.get(this.SERVER_BASEURL + "pdustatusrejectcount/").pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  cristatuscount() {
    return this.httpClient.get(this.SERVER_BASEURL + "cristatuscount/").pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  criresolvecount() {
    return this.httpClient.get(this.SERVER_BASEURL + "criresolvecount/").pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  cripendingcount() {
    return this.httpClient.get(this.SERVER_BASEURL + "cripendingcount/").pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  crirejectcount() {
    return this.httpClient.get(this.SERVER_BASEURL + "crirejectcount/").pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }
  shipped_count(){
    return this.httpClient.get(this.SERVER_BASEURL + "shipped_count/").pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  invigi_eri_total_count(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "invigi_eri_total_count/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  invigi_eri_pending_count(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "invigi_eri_pending_count/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  invigi_eri_resolved_count(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "invigi_eri_resolved_count/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  invigi_eri_rejected_count(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "invigi_eri_rejected_count/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  ccCheck(args: any) {
    return this.httpClient.post(this.SERVER_BASEURL + "ccCheck/", args).pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  getccref(formData: any) {
    // let formatData = new FormData();
    // formatData = {
    //   'action': 'check',
    //   ...args
    // };
    return this.httpClient.post(this.SERVER_BASEURL + "getccref/", formData).pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  utr_check(args:any){
   return this.httpClient.post(this.SERVER_BASEURL + "utr_check/", args).pipe(
      map((data) => {
        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  ///ITI SERVICE///

  
  checkuserid(args: any) {
    this.cc_mob;

    return this.httpClient.post(this.SERVER_BASEURL_ITI + "checkuserid/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  // sendOtp(args: any) {
  //   this.cc_mob;

  //   return this.httpClient.post(this.SERVER_BASEURL + "sendOtp/", args).pipe(
  //     map((data) => {

  //       return data;
  //     }),
  //     retry(1),
  //     catchError(this.handleError)
  //   );
  // }

  checkOtp(args: any) {

    

    return this.httpClient.post(this.SERVER_BASEURL_ITI + "checkOtp/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  checkApiTable(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL_ITI + "checkApiTable/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  checkApi(args: any) {
    const headers = new HttpHeaders({
      "Content-Type": 'application/json;charset=utf-8',
      // 'Content-Type': 'application/json',
      //'Accept': 'application/json',
      //'Access-Control-Allow-Headers': 'Content-Type',
      //'Access-Control-Allow-Headers': '*',
      "loginid": 'NIMI_TraineeDetails',
      "key_spec": 'qiK3aZ4eeeoBZoUlBqSzpA=='
      
    });

    //https://api.ncvtmis.gov.in/nimi/api/getTrainees
   
    
    return this.httpClient.get(this.SERVER_BASEURL1+args.iticode,  { headers: headers }).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );

    // return new Promise((resolve, reject) => {
    //   this.http.post<PostReturn>(`${environment.apiurl}` + '/api/auth/login',
    //     { username: username, password: password }, { headers: headers }).subscribe(
    //       data => {
    //         resolve(data);
    //       }, (err: HttpErrorResponse) => {
    //         reject(err)
    //       });
    // });
  }


  search(q: any) {
    let promise = new Promise((resolve, reject) => {
      let apiURL = this.SERVER_BASEURL1+q.iticode;
      this.httpClient.get(apiURL)
          .toPromise()
          .then(
              res => { // Success
                resolve(res);
                
              },
              msg => { // Error
                reject(msg);
              }
          );
    });
    return promise;
  }

  checkRevrseApi(args: any) {
    // const headers = new HttpHeaders({
    //   "Content-Type": 'application/json;charset=utf-8',
    //   "loginid": 'NIMI_TraineeDetails',
    //   "key_spec": 'qiK3aZ4eeeoBZoUlBqSzpA=='
      
    // });

    
   
    return this.httpClient.post(this.SERVER_BASEURL2, args).pipe(

      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );


  }

  checkApiServer(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL_ITI + "checkApiServer/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  importTable(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL_ITI + "importTable/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  importreTable(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL_ITI + "importreTable/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }
  importTableAll(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL_ITI + "importTableAll/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  showItiTable(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL_ITI + "showItiTable/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  showItiTableCount(args: any) {
    return this.httpClient.get(this.SERVER_BASEURL_ITI + "showItiTableCount/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }


  showItiMasterTable(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL_ITI + "showItiMasterTable/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  showViewPayrefid(args: any) {

    return this.httpClient.post(this.SERVER_BASEURL_ITI + "showViewPayrefid/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
  }
  // payMasterdata(args: any) {
  //   return this.httpClient.post(this.ccref_url11 , args).pipe(
  //     map((data) => {
  //       //alert(data);
  //       return data;
  //     }),
  //     retry(1),
  //     catchError(this.handleError)
  //   );
  // }

  payMasterdata(obj:any ,url:any) {
    var mapForm = document.createElement("form");
    mapForm.target = "_blank";
    mapForm.method = "POST"; // or "post" if appropriate
    mapForm.action = url;
    Object.keys(obj).forEach(function(param){
      var mapInput = document.createElement("input");
      mapInput.type = "hidden";
      mapInput.name = param;
      mapInput.setAttribute("value", obj[param]);
      mapForm.appendChild(mapInput);
  });
  document.body.appendChild(mapForm);
  mapForm.submit();
}

payMasterdel(args: any) {

  return this.httpClient.post(this.SERVER_BASEURL_ITI + "payMasterdel/", args).pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}

checkApiRefresh(args: any) {

  return this.httpClient.post(this.SERVER_BASEURL_ITI + "checkApiRefresh/", args).pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}

showItiTableLimit(args: any) {

  return this.httpClient.post(this.SERVER_BASEURL_ITI + "showItiTableLimit/", args).pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}

showItiTableLimitCount(args: any) {

  return this.httpClient.post(this.SERVER_BASEURL_ITI + "showItiTableLimitCount/", args).pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}

importITI(args: any) {
  return this.httpClient.post(this.SERVER_BASEURL_ITI + "importITI/", args).pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}

countData() {
  return this.httpClient.get(this.SERVER_BASEURL_ITI + "countData/").pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}

countDataItiTable() {
  return this.httpClient.get(this.SERVER_BASEURL_ITI + "countDataItiTable/").pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}

liststateuserlogin(){
  return this.httpClient.get(this.SERVER_BASEURL_ITI + "liststateuserlogin/").pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}


iticodeListtable(query: string, page: number, offset: number){
  return this.httpClient.get(this.SERVER_BASEURL_ITI + "iticodeListtable?q=" + query + "&page=" + page + "&offset=" + offset).pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}

iticodeListtable_count(query: string, page: number, offset: number) {
  return this.httpClient.get(this.SERVER_BASEURL_ITI + "iticodeListtable_count?q=" + query + "&page=" + page + "&offset=" + offset).pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}


iticandidateListtable(query: string, page: number, offset: number){
  return this.httpClient.get(this.SERVER_BASEURL_ITI + "iticandidateListtable?q=" + query + "&page=" + page + "&offset=" + offset).pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}

iticandidateListtable_count(query: string, page: number, offset: number) {
  return this.httpClient.get(this.SERVER_BASEURL_ITI + "iticandidateListtable_count?q=" + query + "&page=" + page + "&offset=" + offset).pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}

paymentverifiedList(query: string, page: number, offset: number){
  return this.httpClient.get(this.SERVER_BASEURL_ITI + "paymentverifiedList?q=" + query + "&page=" + page + "&offset=" + offset).pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}

paymentverifiedList_count(query: string, page: number, offset: number) {
  return this.httpClient.get(this.SERVER_BASEURL_ITI + "paymentverifiedList_count?q=" + query + "&page=" + page + "&offset=" + offset).pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}

paymentverifiedListfilter(args:any){
  return this.httpClient.post(this.SERVER_BASEURL_ITI + "paymentverifiedList",  args).pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}

paymentverifiedListfilter_count(args:any){
  return this.httpClient.post(this.SERVER_BASEURL_ITI + "paymentverifiedList",  args).pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}

  // getccref(formData: any) {
  //   return this.httpClient.post("https://nimionlineadmission.in/AITTCBT-FEES22/Check_CCAvenue.php/", formData).pipe(
  //     map((data) => {
  //       return data;
  //     }),
  //     retry(1),
  //     catchError(this.handleError)
  //   )
  // }




  handleError(error: any) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      errorMessage = `${error.error.message}`;
    } else {
      // server-side error
      //errorMessage = `${error.status} <br /> Message: ${error.message}`;
      errorMessage = `Server Error<br /> Message: ${error.message}`;
    }

    return throwError(errorMessage);
  }

  public get() {
    return this.httpClient.get<any>(this.SERVER_BASEURL);
  }

}
